import { administratorRoles } from "../config/roles";
import {
  AutomationScheduleMode,
  AutomationStatus,
  AutomationType,
} from "../config/enums";
import { enumToOptions } from "../blocks/fields/enumToOptions";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/automation";

const typeOptions = enumToOptions(AutomationType);
const statusOptions = enumToOptions(AutomationStatus);
const scheduleModeOptions = enumToOptions(AutomationScheduleMode);

/**
 * The automations list. Warehouse records are read through the search endpoint, as the
 * legacy table's Search button did, so nothing is read until a search is submitted.
 */
export const automationListListDefinition: ListDefinition = {
  path: "/automation-list",
  entityName: "dwautomation",
  recordRoute,
  title: "Automations",
  allowedRoles: administratorRoles,
  data: "search-paged",
  searchOnLoad: true,
  filters: [
    {
      // Lower case: the repository reads this key from a case-sensitive dictionary.
      name: "name",
      label: "Name",
      kind: "text",
      width: "wider",
    },
    {
      name: "status",
      label: "Status",
      kind: "picklist",
      options: statusOptions,
    },
    { name: "type", label: "Type", kind: "picklist", options: typeOptions },
    {
      name: "campaignid",
      label: "Reporting Campaign",
      kind: "lookup",
      lookupEntity: "campaign",
      searchable: true,
    },
    { name: "createdon", label: "Created", kind: "date-range", advanced: true },
    {
      name: "modifiedon",
      label: "Modified",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: false,
  allowAdd: true,
  addRoles: administratorRoles,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "status",
      label: "Status",
      width: 200,
      sortable: true,
      display: "component",
      componentKey: "automationStatus",
    },
    {
      key: "type",
      label: "Type",
      width: 200,
      sortable: true,
      display: "picklist",
      options: typeOptions,
    },
    {
      key: "schedulemode",
      label: "Schedule Type",
      width: 200,
      sortable: true,
      display: "picklist",
      options: scheduleModeOptions,
    },
    {
      key: "campaignname",
      label: "Reporting Campaign",
      width: 200,
      sortable: true,
      link: { to: "/reporting-campaign", idKey: "campaignid", newTab: "button" },
    },
    {
      key: "communicationname",
      label: "Communication",
      width: 200,
      sortable: true,
      link: { to: "/email-communication", idKey: "communicationid", newTab: "button" },
    },
    {
      key: "audiencename",
      label: "Audience",
      width: 200,
      sortable: true,
      link: { to: "/audience", idKey: "audienceid", newTab: "button" },
    },
    {
      key: "emailssent",
      label: "Emails sent",
      width: 200,
      display: "component",
      componentKey: "automationCount",
    },
    {
      key: "openrate",
      label: "Open rate",
      width: 200,
      display: "component",
      componentKey: "automationRate",
    },
    {
      key: "clickrate",
      label: "Click rate",
      width: 200,
      display: "component",
      componentKey: "automationRate",
    },
    {
      key: "clickstoopenrate",
      label: "CTO",
      width: 200,
      display: "component",
      componentKey: "automationRate",
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    { key: "modifiedbyname",label: "Modified By", width: 200, sortable: true },
  ],
};
